import { render, staticRenderFns } from "./authLink.vue?vue&type=template&id=37ffb402&scoped=true"
import script from "./authLink.vue?vue&type=script&lang=js"
export * from "./authLink.vue?vue&type=script&lang=js"
import style0 from "./authLink.vue?vue&type=style&index=0&id=37ffb402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ffb402",
  null
  
)

export default component.exports